export const translations = {
    stepLabel: {
        START: 'Početak',
        SUBMITTER: 'Podnosilac',
        DETAILS: 'Detalji',
        SPECIFICATION: 'Specifikacija',
        DOCUMENTATION: 'Dokumentacija',
        CONFIRMATION: 'Potvrda',
    },
    legalPersonType: {
        INDIVIDUAL: 'Fizičko lice',
        LEGAL: 'Pravno lice',
    },
    personalInfo: {
        SUBMITTER_ROLE:
            'U kom svojstvu podnosite zahtev za naknadu iz osiguranja (Punomoćnik, roditelj/staratelj, korisnik osiguranja, ugovarač osiguranja, član porodice…)?',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        UCN: 'JMBG',
        ADDRESS: 'Adresa',
        CITY: 'Mesto',
        MOBILE: 'Mobilni telefon',
        MOBILE_STAR: 'Mobilni telefon *',
        DEFAULT_SUBMITTER: 'Ugovarač',
        EMAIL: 'Email',
        PERSON_ROLE: 'Svojstvo',
    },
    legalInfo: {
        PERSON: 'Pravno lice ili preduzetnik',
        CONTACT_INFO: 'Vaši kontakt podaci',
        SUBMITTER_LEGAL_NAME: 'Poslovno ime',
        ID: 'Matični broj',
        VAT: 'PIB',
        EMAIL: 'E-mail',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        MOBILE: 'Mobilni telefon *',
        CONTACT_EMAIL: 'E-mail',
        LEASING: 'Lizing kuća *',
    },
    legalEntityInfo: {
        TITLE: 'Naziv',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
    },
    validationMessages: {
        REQUIRED_FIELD: 'Obavezno polje',
        PHONE_NUMBER_FORMAT: 'Potrebno je uneti broj telefona u odgovarajućem formatu (+xxxxxxxxxx)',
        PHONE_NUMBER_FORMAT_SERBIAN:
            'Morate da unesete broj telefona mobilnog operatera iz Srbije (u obliku +3816xxxxxx)',
        EMAIL_ADDRESS_FORMAT: 'Potrebno je uneti e-mail adresu u odgovarajućem formatu (xx@xx.xx)',
        LEGAL_ENTITY_NUMBER_INVALID_FORMAT: 'Matični broj nije u ispravnom formatu. Proverite podatke.',
        VAT_INVALID_FORMAT: 'Uneti PIB nije u ispravnom formatu. Proverite podatke.',
        UCN_INVALID_FORMAT: 'JMBG nije u odgovarajućem formatu!',
        ALREADY_HAS_UCN: 'Ne možete ponovo dodati isto lice.',
        NOT_ADULT: 'Lice je maloletno.',
        UNIQUE_CITIZEN_NUMBER_AND_BIRTH_NO_NOT_EQUAL: 'Datum rođenja se ne podudara sa JMBG',
        ADD_USER: 'Potrebno je dodati makar jednog korisnika.',
        ACCOUNT_NUMBER_INVALID_FORMAT: 'Broj računa nije u ispravnom formatu. Proverite podatke.',
        INSURED_CASE_ALREADY_EXIST:
            'Za unetog osiguranika već postoji podnet zahtev po odabranoj polisi za isti datum nastanka osiguranog slučaja.',
        INVALID_INSURED_DATE:
            'Za ovo lice nije moguće podneti zahtev sa navedenim datumom nastanka, s obzirom na to kada je stekao status osiguranika.',
        ALREADY_HAS_IMMATERIAL: 'Ne možete ponovo dodati isto lice.',
        NaN: 'Uneti podatak mora biti celobrojna vrednost ili decimalna vrednost sa maksimalno dve decimale (npr: 14; 17.3; 12.20;)',
        CONTACT_REQUIRED: 'Obavezno je uneti jedan kontakt podatak (email ili mobilni telefon)',
        AREA_MAX_SIZE: 'Površina prostorije mora biti manja od 100 m²',
    },
    claimDetail: {
        OBJECT_DETAILS: 'Podaci o objektu',
        OBJECT_TYPE_1: 'Molimo Vas izaberite vrstu objekta',
        OBJECT_TYPE: 'Vrsta objekta',
        ADDRESS_OBJECT_IS_SAME_AS_SUBMITTER: 'Adresa oštećenog objekta je ista kao i adresa podnosioca?',
        OBJECT_CODE: 'Šifra prostora',
        PICK_OWNER: 'Izaberite vlasnika',
        OWNER: 'Vlasnik',
        CLAIM_DETAILS: 'Detalji štete',
    },
    specificationDetail: {
        SPECIFICATION: 'Specifikacija',
    },
    documentation: {
        ADD_DOC: 'Dodajte dokumenta u odgovarajuće kategorije',
        ALLOWED_FILE_FORMATS: 'Dozvoljeni formati su: ',
        TOTAL_UPLOAD_SIZE_LABEL: 'Ukupna veličina priloga koju možete poslati je ',
        TOTAL_UPLOAD_SIZE_LEFT_LABEL: 'Preostala veličina priloga koju možete poslati je ',
        DOCUMENTATION_MB_SPACE: ' MB.',
        LOADING_MESSAGE: 'Podaci se prosleđuju. Molimo sačekajte.',
        COMPRESS_MESSAGE: 'Fajlovi se kompresuju. Molimo sačekajte.',
    },
    success: {
        SUCCESS: 'Uspešno ste prijavili štetu. ',
        CLAIM_NUMBER: 'Broj štete je ',
        NOTIFICATION_SEND: 'Potvrda o prijavi vam je poslata na e-mail.',
    },
    sectionSmsLink: {
        SMS_LINK: 'Da li želite da se procena štete izvrši daljinskim putem? *',
        WHO_SHOULD_WE_SEND_LINK: 'Kom licu da pošaljemo link? *',
        PHONE_NUM_WE_SEND_LINK: 'Na koji broj telefona da pošaljemo link? *',
        ADD_CONTACT: 'Unesite drugi kontakt',
        PHONE_TOOLTIP: 'Morate da unesete broj telefona operatera iz Srbije',
    },
    confirmationScreen: {
        BASIC_INFORMATION: 'Osnovni podaci',
        POLICY_NUMBER: 'Broj polise',
        OPENED_REQUESTS: 'Po slanju podataka otvorićemo sledeće posebne zahteve:',
        REQUEST: 'Zahtev',
        DESCRIPTION: 'Opis',
        VEHICLE_DAMAGE: 'Šteta na vozilu',
        OBJECT_DAMAGE: 'Šteta na objektu ili predmetu',
        DAMAGE_PLACE_AND_ADDRESS: 'Mesto i adresa štete',
        INJURIES: 'Povrede i/ili nematerijalne posledice nezgode',
        AGREEMENT:
            'Saglasan/-na sam da Generali Osiguranje Srbija a.d.o. sa mnom kontaktira, šalje mi korisne informacije, ponude i obaveštenja o proizvodima i uslugama osiguranja.',
        PRIVACY: 'Više o načinu na koji upravljamo vašim podacima možete pročitati u našoj ',
        PRIVACY_POLICY_LINK: 'Politici privatnosti',
        PRIVACY_POLICY_URL: 'https://www.generali.rs/footer.1056.html',
        ENSUREE:
            'Osiguravač nije u obavezi da pruži osiguravajuće pokriće niti da plati bilo kakav odštetni zahtev ili isplati bilo kakvu naknadu na osnovu ugovora o osiguranju u onoj meri u kojoj bi ga pružanje takvog pokrića, plaćanje takvog odštetnog zahteva ili omogućavanje takve naknade izložilo bilo kakvoj sankciji, zabrani ili ograničenju na osnovu rezolucija Ujedinjenih nacija ili trgovinskih ili ekonomskih sankcija, zakona ili propisa Evropske unije, Sjedinjenih Američkih država ili Republike Srbije.',
        WRONG_PASS: 'Lozinka je neispravna ili je istekla. Proverite i pokušajte ponovo.',
        CLAIM_ERROR: 'Šteta nije snimljena. Pokušajte ponovo.',
        DATE: 'Datum nastanka',
        POLICY_SUBMITTER: 'Zahtev podnosi',
        POLICY_SUBMITTER_CONTACT: 'Kontakt podaci podnosioca',
        SEND_LINK: 'Samostalno snimanje štete',
        PAYMENT_DETAILS: 'Detalji isplate',
        SUGGESTED_AMOUNT: 'Brza isplata',
        EXPECTED_AMOUNT: 'Približan iznos štete',
    },
    userNotification: {
        CONFIRMATION_OF_APPLICANT: 'Potvrda podnosioca zahteva',
        RECIEVE_MESSAGE: 'Kliknite da biste dobili kod na imejl',
        SMS: 'SMS',
        EMAIL: 'Imejl',
        MSG_SENT: 'Poslali smo vam imejl',
        ONE_TIME_PASS: 'Jednokratna lozinka *',
        ERROR: 'Ne postoje podaci za unete kontakt podatke i privremenu lozinku!',
    },
    addRoom: {
        CANCEL: 'Odustani',
        SAVE: 'Sačuvaj',
        ADD_NEW: 'Dodaj prostoriju',
        ERROR_MSG_MISSING_SPECIFICATION:
            'Potrebno je popuniti specifikacije za ukupan broj oštećenih prostorija označenih u koraku 3 (Detalji). Broj oštećenih prostorija ',
    },
    room: {
        TYPE: 'Vrsta prostorije',
        AREA: 'Površina prostorije (m²)',
        HEIGHT: 'Visina prostorije (m)',
        TOTAL_AREA_OF_DEMAGED_WALLS: 'Ukupna površina oštećenih zidova (m²)',
        AREA_OF_DEMAGED_ON_WALLS: 'Ukupna površina svih oštećenja na zidovima (m²)',
        IS_TINTED_WALLS: 'Da li su zidovi tonirani',
        AREA_OF_DEMAGED_ON_CEILING: 'Površina ostećenja na plafonu (m²)',
        AREA_OF_DEMAGED_ON_FLOOR: 'Površina oštećenja poda (m²)',
        FLOOR_DAMAGE_TYPE: 'Vrsta oštećenja poda',
        FLOOR_TYPE: 'Vrsta poda',
        CONFIRM_DELETE: 'Da li ste sigurni da želite da obrišete unete podatke za ovu oštećenu prostoriju?',
        IS_DAMAGE_ON_CEILING: 'Da li postoje oštećenja na plafonu?*',
        NUMBER_OF_DAMAGED_WALL: 'Broj zidova prostorije (osim plafona) na kojima postoje oštećenje',
        WALL_FINISH_TYPE: 'Vrsta obrade zidova',
        ROOM_NOTE: 'Napomena',
    },
    tooltips: {
        EXPECTED_AMOUNT_WHOLE_NUMBER: 'Unesite celobrojnu vrednost',
    },
    YES: 'Da',
    NO: 'Ne',
    INSURANCE_METHOD: 'Način osiguranja',
    INSURANCE_METHOD_INSTRUCTIONS_1: 'Molimo Vas izaberite način osiguranja',
    DATE_OF_OCCURANCE: 'Datum nastanka osiguranog slučaja',
    DATE: 'Datum *',
    POLICY_NUMBER: 'Broj polise',
    INSURED_PERSON: 'Osiguranik',
    TIME_PERIOD: 'Period važenja',
    POLICY_INSTRUCTIONS_PORTAL: 'Polisa / objekat*',
    POLICY_SELECT_LABEL: 'Polisa',
    ADDRESS: 'Adresa',
    ADDRESS_NO: 'Broj',
    APARTMENT_NO: 'Broj stana',
    POLICY: 'Polisa',
    PUBLIC_UTILITY: 'Izaberite javno komunalno preduzeće',
    PUBLIC_UTILITY_LABEL: 'Javno komunalno preduzeće',
    REFERENCE_NUMBER: 'Poziv na broj pri uplati premije',
    INSURANCE_CONFIRMATION_ID: 'Broj potvrde o osiguranju',
    UNION: 'Izaberite sindikat',
    UNION_LABEL: 'Sindikat',
    CLAIM_SUBMITTER: 'Podnosilac',
    CITIZENSHIP: 'Državljanstvo',
    COUNTRY: 'Država',
    INSURED_ACTIVE_DATE: 'Od *',
    INSURED_TYPE: 'Osiguranik je naš *',
    DATE_OF_BIRTH: 'Datum rođenja *',
    ZIP_CODE: 'Poštanski broj',
    STREET: 'Ulica i broj',
    CITY: 'Mesto',
    PASSPORT_NUMBER: 'Broj pasoša',
    DAMAGE_OBJECT: 'Šteta je nastala',
    CHOOSE_SUBMITTER_TYPE: 'Želim da zahtev prijavim kao',
    GROUP: 'grupa',
    DAMAGE_TYPE_LABEL: 'Šta je oštećeno? *',
    DAMAGED_ROOMS_LABEL: 'Broj oštećenih prostorija',
    DAMAGE_DESCRIPTION: 'Opis štete *',
    SUGGESTED_AMOUNT_AGREEMENT_LABEL_1: 'Da li ste saglasni da po pregledu zahteva isplatimo ',
    SUGGESTED_AMOUNT_AGREEMENT_LABEL_2: ' dinara kao ukupnu i konačnu naknadu?',
    EXPECTED_AMOUNT_LABEL: 'Približan iznos štete u dinarima',
    EXPECTED_AMOUNT_PLACEHOLDER: 'Iznos štete u dinarima',
    ADD_OWNER: 'Dodaj vlasnika',
    CHOOSE_OWNER_TYPE: 'Vlasnik oštećenog objekta je',
    GET_DAMAGE_PHOTO: 'Daljinska procena',
    CAUSE_TYPE: 'Uzrok',
    REMAINING_CHARACTERS: 'Preostalo karaktera:',
    ACCOUNT_NUM: 'Tekući račun (samo brojevi ili brojevi sa "-")*',
    INTRO_MESSAGE_1_TITLE: 'ZAVRŠITE SVE U JEDNOM POTEZU',
    INTRO_MESSAGE_1_SUBTITLE: '10 minuta vašeg vremena',
    INTRO_MESSAGE_1_LINE_1_1: 'Fotografišite oštećenja',
    INTRO_MESSAGE_1_LINE_1_2: ' i pripremite ',
    INTRO_MESSAGE_1_LINE_1_3: 'potrebna dokumenta.',
    INTRO_MESSAGE_1_LINE_2_1: 'Popunite ',
    INTRO_MESSAGE_1_LINE_2_2: 'onlajn prijavu.',
    INTRO_MESSAGE_1_LINE_3_1: 'Dobićete potvrdu prijave',
    INTRO_MESSAGE_1_LINE_3_2: ' na dostavljenu imejl adresu odmah po slanju prijave.',
    INTRO_MESSAGE_1_LINE_4: 'Na dostavljenu imejl adresu dobijaćete obaveštenja i odluke o prijavljenoj šteti.',
    INTRO_MESSAGE_1_LINE_5_1: 'Status',
    INTRO_MESSAGE_1_LINE_5_2: ' i ishode možete pratiti na ',
    INTRO_MESSAGE_1_LINE_5_3: 'Portalu za klijente',
    INTRO_MESSAGE_1_LINE_5_4: ' (fizička lica) ili ',
    INTRO_MESSAGE_1_LINE_5_5: 'ovde',
    INTRO_MESSAGE_1_LINE_5_6: '.',
    INTRO_MESSAGE_1_LINK_1: 'https://www.generali.rs/portal_za_klijente.1068.html',
    INTRO_MESSAGE_1_LINK_2: 'https://www.generali.rs/status_stete/provera_statusa_stete.1249.html',
    INTRO_MESSAGE_2_TITLE: 'OBAVEZNA DOKUMENTACIJA',
    INTRO_MESSAGE_2_SUBTITLE_1: 'FOTOGRAFIŠITE OŠTEĆENJA',
    INTRO_MESSAGE_2_LINE_1:
        'Fotografišite oštećenja pre početka prijave. Ukoliko prijavu popunjavate putem mobilnog telefona, oštećenja možete fotografisati u toku prijave.',
    INTRO_MESSAGE_2_LINE_10: 'Fotografije će se automatski kompresovati pri dodavanju u prijavu.',
    INTRO_MESSAGE_2_LINE_2: 'Šta je potrebno da fotografišem?',
    INTRO_MESSAGE_2_LINE_3: 'Celu prostoriju tako da se jasno vide oštećenja',
    INTRO_MESSAGE_2_LINE_4: 'Oštećene površine (zidovi, pod, plafon) odnosno detalje oštećenja',
    INTRO_MESSAGE_2_LINE_5: 'Oštećene stvari (iz više uglova), ako postoje i drugo',
    INTRO_MESSAGE_2_LINE_6: 'Ponovite postupak za svaku prostoriju sa oštećenjima i/ili oštećenu stvar.',
    INTRO_MESSAGE_2_SUBTITLE_2: 'TEKUĆI RAČUN',
    INTRO_MESSAGE_2_LINE_7: 'Kartica tekućeg računa',
    INDIVIDUAL_CONTACT_INFO_VERIFICATION: 'Kontakt podaci biće verifikovani u koraku "Potvrda"',
};

export class constValues {
    static readonly countrySerbiaId: number | string = '197';
    static readonly dialCodeSerbia: string = '+381';
    static readonly damageTypeWallsCeiling: number = 2;
    static readonly damageRoomsOne: number = 1;
}

export enum causeType {
    installationDamage = 150,
    seepageDamage = 142,
    storm = 2,
}

export enum personType {
    initialValue = 0,
    submitter = 1,
    insured = 2,
    user = 3,
    initialUser = 4,
    owner = 5,
}

export enum legalPersonType {
    initialValue = '0',
    individual = '1',
    legal = '2',
}

export const personValidationFields = {
    ucn: 'jmbg',
    email: 'email',
    emailContact: 'emailKontakt',
    phone: 'mobilniTelefon',
};

export const policiesProperties = {
    policyNumber: 'brojPolise',
    address: 'adresa',
    city: 'mesto',
    validFrom: 'vaziOd',
    validTo: 'vaziDo',
    message: 'poruka',
    insuredPersonUCN: 'jmbgOsiguranik',
    suggestedAmount: 'predlozeniIznos',
    firstClaim: 'prvaSteta',
    reportedClaims: 'prijavljeneStete',
    insuranceMethodIDForBE: 'nacinOsigID',
    insuranceMethodIDFromBE: 'nacinOsiguranjaID',
};

export enum insuranceGroup {
    initialValue = 0,
    policyNumber = 1,
    mobileOrWebApp = 2,
    directMail = 3,
    publicUtility = 4,
    union = 5,
    policyNumberBasic = 6,
}

export enum objectType {
    initialValue = '',
    insured = '1',
    other = '2',
}

export const objectTypeOptions = [
    {
        id: objectType.insured,
        value: 'Na osiguranom objektu',
    },
    {
        id: objectType.other,
        value: 'Na drugom objektu odgovornošću osiguranika',
    },
];

export const question1000MaxLength = 1000;
export const question500MaxLength = 500;
export const questionMaxLength = 100;
export const question50MaxLength = 50;
export const question25MaxLength = 25;
export const question10MaxLength = 10;
export const question18MaxLength = 18;
export const policyNoMaxLength = 10;
export const offerNoMaxLength = 10;
export const nameMaxLength = 20;
export const surnameMaxLength = 30;
export const ucnMaxLength = 13;

export enum smsLinkPersonType {
    initialValue = 0,
    submitter = 1,
    owner = 2,
    submitterLegal = 3,
    thirdParty = 99,
}

export const damagedRoomsOptions = [
    {
        id: 1,
        value: '1',
    },
    {
        id: 2,
        value: '2',
    },
    {
        id: 3,
        value: '3',
    },
    {
        id: 4,
        value: 'Više od 3',
    },
];

export enum floorType {
    parquet = 1,
    laminate = 2,
}

export enum floorDamageType {
    bumpy = 1,
    liftedUp = 2,
}

export const numberOfDamagedRoomsOptions = [
    {
        id: 0,
        value: 'Nema oštećenja',
    },
    {
        id: 1,
        value: '1',
    },
    {
        id: 2,
        value: '2',
    },
    {
        id: 3,
        value: '3',
    },
    {
        id: 4,
        value: 'Svi zidovi',
    },
];
